import { render, staticRenderFns } from "./DetalhesFaturamento.vue?vue&type=template&id=1b283901&"
import script from "./DetalhesFaturamento.vue?vue&type=script&lang=js&"
export * from "./DetalhesFaturamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports